import { Button, Modal } from "react-bootstrap"

export function ConfirmModal(props: {
    active: boolean,
    onClose: () => void,
    onConfirm: () => void,
    message: string
    title: string
    disabled?: boolean
}) {

    const {
        active,
        onClose,
        onConfirm,
        message,
        title,
        disabled = false
    } = props

    return (
        <Modal
            show={active}
            onHide={() => {
                if (disabled) return
                onClose()
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-lg font-semibold">{message}</p>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="primary" onClick={onConfirm} disabled={disabled}>
                    Confirm
                </Button>


                <Button variant="secondary" onClick={onClose} disabled={disabled}>
                    Cancel
                </Button>

            </Modal.Footer>
        </Modal >
    )
}